import React, { useState, FormEvent } from "react";

import { TextInput } from "../reusables/FormElements";

import { Logos } from "../../data/Assets";

import validationHelper from "../../helpers/validators";

import useSignIn from "../../hooks/auth/useSignIn";
import { ImageAsset } from "../wrappers/ImageAsset";

const LoginPage = () => {
    const [username, setUsername] = useState({ value: "", error: "" });
    const [password, setPassword] = useState({ value: "", error: "" });
    const [isProcessing, setIsProcessing] = useState(false);
    const [apiError, setApiError] = useState("");

    const { mutate: signIn } = useSignIn();

    const onSignIn = (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        if (isProcessing) return;

        setUsername({ ...username, error: "" });
        setPassword({ ...password, error: "" });
        setApiError("");

        const passwordValError = validationHelper.validateInput("password", password.value);
        if (passwordValError) {
            setPassword({ ...password, error: passwordValError });
        };

        if (passwordValError) return;

        setIsProcessing(true);

        signIn({
            creds: {
                username: username.value,
                password: password.value
            },
            setApiError,
            setIsProcessing,
        });
    };

    return (
        <div className="immployer_admin__login__page_view">
            <br /><br /><br />
            <ImageAsset className="immployer_admin__auth_logo" src={Logos.Logo} alt="" />
            <br />
            <h3 className="color_dark text_center">Immployer Admin Sign In</h3>
            <br /><br />
            <form onSubmit={onSignIn}>
                <TextInput
                    name="username"
                    type="text"
                    label="Username"
                    required={true}
                    errorMsg={username.error}
                    placeholder="Enter your email"
                    onChange={(value: string) => setUsername({ ...username, value })}
                    value={username.value}
                />
                <br />
                <TextInput
                    name="password"
                    type="password"
                    label="Password"
                    required={true}
                    errorMsg={password.error}
                    placeholder="Enter your password"
                    onChange={(value: string) => setPassword({ ...password, value })}
                    value={password.value}
                />
                <br />
                <button
                    className="btn_block immployer_admin__btn immployer_admin__btn__primary"
                    type="submit"
                    disabled={isProcessing}
                >
                    {
                        isProcessing
                            ? <i className='immployer_admin__btn_loader' />
                            : 'Sign In'
                    }
                </button>
            </form>
            {apiError?.length > 0 && <p className="immployer_admin__auth_api_error">{apiError}</p>}
        </div>
    );
};

export default LoginPage;